"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
function gte(path, min, unit) {
    return (value) => {
        if (value < min) {
            return E.left([
                new _1.ValidationError(path, `${value} is less than ${min}`, new GteInfo(value, min, unit)),
            ]);
        }
        return E.right(value);
    };
}
exports.gte = gte;
class GteInfo {
    constructor(actual, min, unit = '') {
        this.actual = actual;
        this.min = min;
        this.unit = unit;
        this.type = 'greaterThanOrEqual';
    }
}
function lte(path, max, unit) {
    return (value) => {
        if (value > max) {
            return E.left([
                new _1.ValidationError(path, `${value} is greater than ${max}`, new LteInfo(value, max, unit)),
            ]);
        }
        return E.right(value);
    };
}
exports.lte = lte;
class LteInfo {
    constructor(actual, max, unit = '') {
        this.actual = actual;
        this.max = max;
        this.unit = unit;
        this.type = 'lessThanOrEqual';
    }
}
function range(path, min, max, unit) {
    return (x) => {
        if (x < min || x > max) {
            return E.left([
                new _1.ValidationError(path, `${x} must be within ${min} - ${max}`, new RangeInfo(x, min, max, unit)),
            ]);
        }
        return E.right(x);
    };
}
exports.range = range;
class RangeInfo {
    constructor(actual, min, max, unit = '') {
        this.actual = actual;
        this.min = min;
        this.max = max;
        this.unit = unit;
        this.type = 'withinRange';
    }
}
